import React from 'react';
import { Container, Grid, Typography } from '@mui/material';
import { sxStyle } from './styles';

const NoResultsHotelSearch = ({ city }) => {
  return (
    <Container sx={sxStyle.root}>
      <Grid>
        <Typography variant="h5" sx={sxStyle.noResultsText} align="center">
          Lo sentimos, no se encontraron resultados disponibles en
        </Typography>
        <Typography sx={sxStyle.noCity}>{` ${city}`}</Typography>
      </Grid>
    </Container>
  );
};

export default NoResultsHotelSearch;
